<template>
  <div>
    <div class="modal fade" id="modal-seguimientos-cargues">
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">Seguimientos de Cargues</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              ref="closeModal"
              id="close-modal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body p-0">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="tab-InfoTurno"
                  data-toggle="tab"
                  href="#check_filtros"
                  >Listado</a
                >
              </li>
              <li class="nav-item active">
                <a
                  class="nav-link active"
                  id="tab-InfoTurno"
                  data-toggle="tab"
                  href="#input_filtros"
                  >Filtros</a
                >
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane" id="check_filtros">
                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-11">
                      <div class="form-group">
                        <div
                          v-for="col in columnasPlantilla"
                          :key="col.id"
                          class="mb-1"
                        >
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              class="custom-control-input"
                              :id="'check_' + col.id"
                              v-model="check[col.id]"
                            />
                            <label
                              class="custom-control-label"
                              :for="'check_' + col.id"
                              :class="check[col.id] ? 'text-primary' : ''"
                              >{{ col.label }}</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade active show" id="input_filtros">
                <div class="card-body">
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label :class="filtros.fecha_ini ? 'text-success' : ''"
                        >Fecha Inicio</label
                      >
                      <input
                        type="date"
                        class="form-control form-control-sm shadow-sm"
                        v-model="filtros.fecha_ini"
                        @input="validaFechas"
                        :class="[
                          $v.filtros.fecha_ini.$invalid
                            ? 'is-invalid'
                            : 'is-valid',
                          filtros.fecha_ini ? 'border-success' : '',
                        ]"
                      />
                    </div>
                    <div class="form-group col-md-6">
                      <label :class="filtros.fecha_fin ? 'text-success' : ''"
                        >Fecha fin</label
                      >
                      <input
                        type="date"
                        class="form-control form-control-sm shadow-sm"
                        v-model="filtros.fecha_fin"
                        @input="validaFechas"
                        :class="[
                          $v.filtros.fecha_fin.$invalid
                            ? 'is-invalid'
                            : 'is-valid',
                          filtros.fecha_fin ? 'border-success' : '',
                        ]"
                      />
                    </div>
                    <div class="form-group col-md-6">
                      <label :class="filtros.hora_inicio ? 'text-success' : ''"
                        >Hora inicio</label
                      >
                      <input
                        type="text"
                        class="form-control form-control-sm shadow-sm"
                        :class="filtros.hora_inicio ? 'border-success' : ''"
                        v-model="filtros.hora_inicio"
                        @input="sanitizarHora24h('hora_inicio')"
                        v-mask="{
                          mask: '99:99',
                          hourFormat: '24',
                        }"
                      />
                    </div>
                    <div class="form-group col-md-6">
                      <label :class="filtros.hora_fin ? 'text-success' : ''"
                        >Hora fin</label
                      >
                      <input
                        type="text"
                        class="form-control form-control-sm shadow-sm"
                        :class="filtros.hora_fin ? 'border-success' : ''"
                        v-model="filtros.hora_fin"
                        @input="sanitizarHora24h('hora_fin')"
                        v-mask="{
                          mask: '99:99',
                          hourFormat: '24',
                        }"
                      />
                    </div>
                    <div class="form-group col-md-12">
                      <label :class="filtros.remito ? 'text-success' : ''"
                        >Remito</label
                      >
                      <input
                        type="number"
                        class="form-control form-control-sm shadow-sm"
                        :class="filtros.remito ? 'border-success' : ''"
                        v-model="filtros.remito"
                      />
                    </div>
                    <div class="form-group col-md-6">
                      <label :class="filtros.camion_id ? 'text-success' : ''"
                        >Camion</label
                      >
                      <v-select
                        v-model="camion"
                        placeholder="Camion"
                        label="placa"
                        class="form-control form-control-sm shadow-sm p-0"
                        :class="filtros.camion_id ? 'border-success' : ''"
                        :options="listasForms.camiones"
                        @search="buscarCamiones"
                        @input="selectCamion()"
                      ></v-select>
                    </div>
                    <div class="form-group col-md-6">
                      <label :class="filtros.cisterna_id ? 'text-success ' : ''"
                        >Cisterna</label
                      >
                      <v-select
                        v-model="cisterna"
                        placeholder="Cisterna"
                        label="placa"
                        class="form-control form-control-sm shadow-sm p-0"
                        :class="filtros.cisterna_id ? 'border-success ' : ''"
                        :options="listasForms.cisternas"
                        @search="buscarCisternas"
                        @input="selectCisterna()"
                      ></v-select>
                    </div>
                    <div class="form-group col-md-8">
                      <label :class="filtros.chofer_id ? 'text-success ' : ''"
                        >Chofer</label
                      >
                      <v-select
                        v-model="chofer"
                        placeholder="Chofer"
                        label="nombre"
                        class="form-control form-control-sm shadow-sm p-0"
                        :class="filtros.chofer_id ? 'border-success ' : ''"
                        :options="listasForms.choferes"
                        @search="buscarChoferes"
                        @input="selectChofer()"
                      ></v-select>
                    </div>
                    <div class="form-group col-md-4">
                      <label :class="filtros.instalacion ? 'text-success ' : ''"
                        >Instalación</label
                      >
                      <select
                        v-model="filtros.instalacion"
                        class="form-control form-control-sm"
                        :class="filtros.instalacion ? 'border-success ' : ''"
                      >
                        <option value="">Seleccione...</option>
                        <option
                          v-for="instalacion in listasForms.instalaciones"
                          :key="instalacion.numeracion"
                          :value="instalacion.numeracion"
                        >
                          {{ instalacion.descripcion }}
                        </option>
                      </select>
                    </div>
                    <div class="form-group col-md-12">
                      <label :class="filtros.empresa_id ? 'text-success ' : ''"
                        >Empresa</label
                      >
                      <v-select
                        v-model="empresa"
                        placeholder="Empresa"
                        label="razon_social"
                        class="form-control form-control-sm shadow-sm p-0 col-md-12"
                        :class="filtros.empresa_id ? 'border-success ' : ''"
                        :options="listasForms.empresas"
                        @search="buscarEmpresas"
                        @input="selectEmpresa()"
                      ></v-select>
                    </div>
                    <div class="form-group col-md-12">
                      <label :class="filtros.isla_id ? 'text-success' : ''"
                        >Isla</label
                      >
                      <div class="mt-0">
                        <v-select
                          v-model="isla"
                          placeholder="Isla"
                          label="nombre"
                          class="form-control form-control-sm shadow-sm p-0 col-md-12"
                          :class="filtros.isla_id ? 'border-success' : ''"
                          :options="listasForms.islas"
                          @search="buscarIslas"
                          @input="selectIsla()"
                        ></v-select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer justify-content-between">
            <div>
              <button
                type="button"
                class="btn btn-sm bg-gradient-navy shadow mr-2"
                @click="exportExcel"
                v-if="!$v.filtros.$invalid"
              >
                Generar Listado
                <i class="fas fa-file-download"> </i>
              </button>
              <button
                type="button"
                class="btn btn-sm bg-gradient-danger shadow"
                @click="limpiarModal()"
              >
                Limpiar
                <i class="fas fa-file-download"> </i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import vSelect from "vue-select";
import { required } from "vuelidate/lib/validators";

export default {
  name: "SeguimientoCargueExcel",
  components: {
    vSelect,
  },
  data() {
    const columnasPlantilla = [
      { id: "fecha", label: "FECHA", checked: true },
      { id: "hora_inicio", label: "HORA INICIO", checked: true },
      { id: "hora_final", label: "HORA FINAL", checked: true },
      { id: "camion", label: "CAMION", checked: true },
      { id: "cisterna", label: "CISTERNA", checked: true },
      { id: "cliente", label: "CLIENTE", checked: true },
      { id: "transporte", label: "TRANSPORTE", checked: true },
      { id: "chofer", label: "CHOFER", checked: true },
      { id: "documento", label: "DOCUMENTO", checked: true },
      { id: "numero_carga", label: "N° CARGA", checked: true },
      { id: "remito", label: "REMITO", checked: true },
      { id: "producto", label: "PRODUCTO", checked: true },
      { id: "volumen_cargado", label: "VOLUMEN CARGADO lts", checked: true },
      {
        id: "temperatura_tk_mas",
        label: "TEMPERATURA TK °C",
        checked: true,
      },
      { id: "porcentaje_agua", label: "% AGUA", checked: true },
      {
        id: "densidad",
        label: "DENSIDAD",
        checked: true,
      },
      {
        id: "t_muestra",
        label: "T° MUESTRA °C",
        checked: true,
      },
      { id: "sales", label: "SALES G/M3", checked: true },
      {
        id: "volumen_oil_hidratado",
        label: "VOLUMEN OIL HIDRATADO",
        checked: true,
      },
      {
        id: "temperatura_promedio",
        label: "TEMP PROMEDIO",
        checked: true,
      },
      { id: "factor_correccion", label: "FACTOR CORRECCION", checked: true },
      {
        id: "volumen_a_15",
        label: "VOL TOTAL HIDRATADO A 15°",
        checked: true,
      },
      {
        id: "volumen_agua_sedimento",
        label: "VOL AGUA Y SEDIMENTOS",
        checked: true,
      },
      {
        id: "volumen_total_sec_sec",
        label: "VOLUMEN TOTAL SEC-SEC",
        checked: true,
      },
      { id: "gravedad_api", label: "GRAVEDAD API", checked: true },
      { id: "isla", label: "ISLA", checked: true },
      {
        id: "volumen_masico_inicial",
        label: "VOLUMEN MASICO INICIAL",
        checked: true,
      },
      {
        id: "volumen_masico_final",
        label: "VOLUMEN MASICO FINAL",
        checked: true,
      },
      { id: "numero_pedido", label: "N° PEDIDO", checked: true },
      { id: "n_instalacion", label: "N° INSTALACION", checked: true },
    ];
    const check = {};
    columnasPlantilla.forEach((c) => (check[c.id] = true));
    return {
      columnasPlantilla,
      check,
      filtros: {
        remito: null,
        camion_id: null,
        cisterna_id: null,
        chofer_id: null,
        empresa_id: null,
        isla_id: null,
        cliente_id: null,
        fecha_ini: null,
        fecha_fin: null,
        hora_inicio: null,
        hora_fin: null,
        instalacion: null,
      },
      listasForms: {
        camiones: [],
        cisternas: [],
        choferes: [],
        empresas: [],
        islas: [],
        clientes: [],
        instalaciones: [],
      },
      camion: {},
      cisterna: {},
      chofer: {},
      empresa: {},
      isla: {},
      cliente: {},
    };
  },

  validations: {
    filtros: {
      fecha_ini: {
        required,
      },
      fecha_fin: {
        required,
      },
    },
  },

  methods: {
    sanitizarHora24h(campo) {
      this.$nextTick(() => {
        const raw = this.filtros[campo];
        if (raw == null || raw === "") return;
        const flat = String(raw).replace(/\D/g, "");
        if (flat.length < 2) return;
        const h0 = parseInt(flat.slice(0, 2), 10);
        const h = Math.min(23, Math.max(0, h0));
        const rest = flat.slice(2);
        if (rest.length < 2) {
          if (h0 === h) return;
          this.filtros[campo] = rest.length
            ? `${String(h).padStart(2, "0")}:${rest}`
            : `${String(h).padStart(2, "0")}:`;
          return;
        }
        const m0 = parseInt(rest.slice(0, 2), 10);
        const m = Math.min(59, Math.max(0, m0));
        if (h0 === h && m0 === m) return;
        this.filtros[campo] = `${String(h).padStart(2, "0")}:${String(
          m,
        ).padStart(2, "0")}`;
      });
    },

    limpiarModal() {
      this.columnasPlantilla.forEach((c) => (this.check[c.id] = true));
      this.filtros = {
        camion_id: null,
        cisterna_id: null,
        chofer_id: null,
        empresa_id: null,
        isla_id: null,
        cliente_id: null,
        fecha_ini: null,
        fecha_fin: null,
        hora_inicio: null,
        hora_fin: null,
      };
      this.camion = {};
      this.cisterna = {};
      this.chofer = {};
      this.empresa = {};
      this.isla = {};
      this.cliente = {};
    },

    selectCamion() {
      this.filtros.camion_id = null;
      if (this.camion) {
        this.filtros.camion_id = this.camion.id;
      }
    },

    selectChofer() {
      this.filtros.chofer_id = null;
      if (this.chofer) {
        this.filtros.chofer_id = this.chofer.id;
      }
    },

    selectEmpresa() {
      this.filtros.empresa_id = null;
      if (this.empresa) {
        this.filtros.empresa_id = this.empresa.id;
      }
    },

    selectCliente() {
      this.filtros.cliente_id = null;
      if (this.cliente) {
        this.filtros.cliente_id = this.cliente.id;
      }
    },

    selectIsla() {
      this.filtros.isla_id = null;
      if (this.isla) {
        this.filtros.isla_id = this.isla.id;
      }
    },

    buscarIslas(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "/api/argentina/sitios/lista?sitio=" + search;
        axios
          .get(url, {
            params: {
              pais_id: 3,
            },
          })
          .then(function(response) {
            me.listasForms.islas = response.data;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            loading(false);
          });
      }
    },

    buscarChoferes(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "/api/argentina/choferes/lista?nombre=" + search;
        axios
          .get(url, {
            params: {
              pais_id: 3,
            },
          })
          .then(function(response) {
            me.listasForms.choferes = response.data;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrió un error - " + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            loading(false);
          });
      }
    },

    buscarEmpresas(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "/api/argentina/empresas/lista?estado=1?nombre=" + search;
        axios
          .get(url, {
            params: {
              pais_id: 3,
            },
          })
          .then(function(response) {
            me.listasForms.empresas = response.data;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrió un error: " + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            loading(false);
          });
      }
    },

    buscarCamiones(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "/api/argentina/camiones/lista?nombre=" + search;
        axios
          .get(url, {
            params: {
              pais_id: 3,
            },
          })
          .then(function(response) {
            me.listasForms.camiones = response.data;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrió un error: " + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            loading(false);
          });
      }
    },

    buscarCisternas(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "/api/argentina/trailers/lista?nombre=" + search;
        axios
          .get(url, {
            params: {
              pais_id: 3,
            },
          })
          .then(function(response) {
            me.listasForms.cisternas = response.data;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrió un error: " + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            loading(false);
          });
      }
    },

    getInstalaciones() {
      let me = this;
      axios.get("/api/lista/231").then((response) => {
        me.listasForms.instalaciones = response.data;
      });
    },

    exportExcel() {
      this.$parent.cargando = true;
      axios({
        method: "POST",
        url: "/api/argentina/controlesCargues/seguimientoCargueExcel",
        data: { check: this.check, filtros: this.filtros },
      })
        .then((response) => {
          let data = response.data;
          this.$parent.cargando = false;
          location.href = data.url;
          this.$swal({
            icon: "success",
            title: "Seguimiento de Cargues generado correctamente",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.$parent.cargando = false;
        });
    },

    validaFechas() {
      if (this.filtros.fecha_ini && this.filtros.fecha_fin) {
        var fecha_menor = new Date(this.filtros.fecha_ini);
        var fecha_mayor = new Date(this.filtros.fecha_fin);
        // Se valida que la fecha inicial sea menor que la fecha final
        if (fecha_menor > fecha_mayor) {
          this.filtros.fecha_fin = null;
          this.$swal({
            icon: "error",
            title: `La fecha inicial no puede ser mayor a la fecha final...`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        }
      }

      /* if (this.filtros.fecha_ini && this.filtros.fecha_fin) {
        fecha_menor = new Date(this.filtros.fecha_ini).getTime();
        fecha_mayor = new Date(this.filtros.fecha_fin).getTime();
        var diff = fecha_mayor - fecha_menor;
        var fecha_limite = diff / (1000 * 60 * 60 * 24);
        if (fecha_limite > 31) {
          this.filtros.fecha_fin = null;
          this.$swal({
            icon: "error",
            title: `Las fechas no pueden ser mayor a 31 dias...`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        }
      } */
    },
  },
};
</script>
